"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mround_1 = require("./mround");
var precisionsz = ['', '.0', '.00', '.000', '.0000', '.00000', '.000000', '.0000000', '.00000000'];
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 8
 */
function fnumber(value, precision) {
    if (precision === void 0) { precision = 8; }
    if (value === null) {
        return '';
    }
    // const s = value.toFixed(2);
    // let s = mround(value, precision).toFixed(precision);
    if (value % 1 === 0) {
        return value.toString();
    }
    return mround_1.default(value, precision)
        .toString()
        .replace('.', ',');
}
exports.default = fnumber;
//# sourceMappingURL=fnumber.js.map